export { default as AppInfoFull } from './infoFull';
export { default as AppInfoShort } from './infoShort';
